<template>
  <!--  ==============================  MODAL_SECTION START ============================== -->
  <b-modal
    id="modal-objects"
    :title="editMode == true ?  $t('edit__oject') : $t('add__oject')"
    cancel-variant="outline-secondary"
    :ok-title="editMode == true ? $t('general.edit') :$t('general.add')"
    ok-variant="success"
    :cancel-title="$t('general.close')"
    centered
    no-close-on-backdrop
    @cancel="onCancel"
    @close="onCancel"
    @show="showModal"
    @ok="onSubmitObects"
  >
    <b-form>
      <validation-observer ref="obectsValidations">
        <b-form-group for="title" :label="$t('namee')">
          <validation-provider
            #default="{ errors }"
            :name="$t('namee')"
            rules="required"
          >
            <b-form-input id="title" v-model="object.title" />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </validation-observer>
    </b-form>
  </b-modal>
  <!--  ==============================  MODAL_SECTION END ============================== -->
</template>

<script>
import { BModal, VBModal, BForm, BFormInput, BFormGroup } from "bootstrap-vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions } from "vuex";

export default {
  name: "AddEditModal",
  components: {
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    "b-modal": VBModal,
  },
  props: {
    editObects: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {



      // ===============  PRIMARY_DATA_SECTION START ===============
      object: {
        title: "",
      },
      // ===============  PRIMARY_DATA_SECTION END ===============
      editMode: false,



    };
  },
  methods: {
    ...mapActions("obectsWarehouse", [
      "CREATE_OBECTS",
      "UPDATE_OBECTS",
    ]),




    // ===============  ON_SHOW_SECTION START ===============
    showModal() {
      this.editMode = this.$route.params.editMode
      this.object = {
        title: "",
      };
      if (!this.editObects) {
        return;
      }

      if (typeof this.editObects === "object" && this.editObects !== null) {
        this.object.title = this.editObects.title;
      }
    },
    // ===============  ON_SHOW_SECTION END ===============



    onCancel(){
      this.$route.params.editMode = false
    },
    onClose(){
      this.$route.params.editMode = false
    },



    // ===============  ON_SUBMIT_SECTION START ===============
    onSubmitObects(bvModalEvt) {
      bvModalEvt.preventDefault();

      this.$refs.obectsValidations.validate().then((success) => {
        if (!success) {
          this.$_errToast({message: this.$t('all_fields_are_required')});
          return;
        }

        try {
          if (this.editObects.id) {
            this.UPDATE_OBECTS({
              id: this.editObects.id,
              data: this.object,
            }).then(async () => {
              await this.$parent.refresh()
            });
          } else {
            this.CREATE_OBECTS(this.object).then(async () => {
              await this.$parent.refresh()
            });
          }

          this.$nextTick(() => {
            this.$route.params.editMode = false
            this.$bvModal.hide("modal-objects");
          });

          this.object = {
            title: "",
          };

          this.$_okToast();
        } catch (err) {
          this.$_errToast(err);
        }
      });
    },
    // ===============  ON_SUBMIT_SECTION END ===============





  },
};
</script>

<style scoped>
</style>
